<script>
export default {
  methods: {
    hasMultipleResendCountries (invoices) {
      const countries = new Set(invoices
        .map(invoice => invoice.buyerCountryId)
        .filter(countryId => countryId !== null && countryId !== undefined)
        .map(String))
      return countries.size > 1
    },
    getResendCountryParams (invoices) {
      return {
        filterByBuyerCountry: true,
        buyerCountryId: invoices.length > 0 && invoices.every(invoice => invoice.buyerCountryId != null) ? invoices[0].buyerCountryId : null
      }
    },
    resetResendInvoiceDialog () {
      this.isShowDialogResendInvoice = false
      this.metodosenvio = []
      this.dialogResendInvoiceForm.communicationMethodId = null
      this.dialogResendInvoiceForm.isDefault = false
      this.dialogResendInvoiceForm.newEmails = ''
    }
  }
}
</script>
